/**
 * "Valid" domains in this case include only hostnames, not IP addresses.
 * If no valid domains are passed, it returns `['localhost']`.
 */
export function getValidDomains(domain: undefined | string | string[]): string[] {
  const domains = [...(Array.isArray(domain) ? domain : [domain])].filter((value: undefined | string): boolean => {
    // Only create certificates for valid hostnames, not ip addresses.
    return !!value && !/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value);
  }) as string[];

  if (domains.length === 0) {
    domains.push('localhost');
  }

  return domains;
}
